import {parseQuery} from 'shared/utils/searchQuery';

type Dependencies = {
  location?: Location;
};

export function initialSettings(di: Dependencies = {}): MaybeNull<RemoteSettings> {
  const {location = window.location} = di;

  const settings = parseQuery(location.href);
  const amount = Number(settings?.amount);
  const daysCount = Number(settings?.days);

  if (Number.isNaN(amount) || Number.isNaN(daysCount)) return null;
  return {amount, daysCount};
}
